import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';

import { DataSource } from '../../../../lib/data-source/data-source';
import { Column } from '../../../../lib/data-set/column';

@Component({
    selector: 'ng2-smart-table-title',
    styleUrls: ['./title.component.scss'],
    template: `
      @if (column.isSortable) {
        <a href="#" (click)="_sort($event)" class="ng2-smart-sort-link sort" [ngClass]="currentDirection">
          {{ column.title }}
        </a>
      }
      @if (!column.isSortable) {
        <span class="ng2-smart-sort">{{ column.title }}</span>
      }
    `,
    standalone: false
})
export class TitleComponent implements OnChanges {

  public currentDirection = '';
  @Input() public column: Column;
  @Input() public source: DataSource;
  @Output() public sort = new EventEmitter<any>();

  protected dataChangedSub: Subscription;

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.source) {
      if (!changes.source.firstChange) {
        this.dataChangedSub.unsubscribe();
      }
      this.dataChangedSub = this.source.onChanged().subscribe((dataChanges) => {
        const sortConf = this.source.getSort();

        if (sortConf.length > 0 && sortConf[0]['field'] === this.column.id) {
          this.currentDirection = sortConf[0]['direction'];
        } else {
          this.currentDirection = '';
        }
        sortConf.forEach((fieldConf: any) => {
          // do nothing
        });
      });
    }
  }

  public _sort(event: any) {
    event.preventDefault();
    this.changeSortDirection();
    this.source.setSort([
      {
        field: this.column.id,
        direction: this.currentDirection,
        compare: this.column.getCompareFunction(),
      },
    ]);
    this.sort.emit(null);
  }

  public changeSortDirection(): string {
    if (this.currentDirection) {
      const newDirection = this.currentDirection === 'asc' ? 'desc' : 'asc';
      this.currentDirection = newDirection;
    } else {
      this.currentDirection = this.column.sortDirection;
    }
    return this.currentDirection;
  }
}
